import React, {useEffect, useMemo, useState} from 'react';
import dynamic from 'next/dynamic';
import ProductCell from "./ProductCell";
import Utils from "@/utils/Default/Utils";
import ProductCellBanner from "./ProductCellBanner";
import AutoPromoAddSenseBanners from "./AutoPromoAddSenseBanners";
import {useSelector} from "react-redux";
import SeePaginatorButton from "./SeePaginatorButton";
import Placeholder from "./Placeholder";

const AdsenseBloc = dynamic(
    () => import('../Common/AdsenseBloc'),
    {ssr: false}
)
const DynamicComponentPaginator = dynamic(() =>
    import('./Paginator')
)
const RattachementModalWithNoSSR = dynamic(() => import('./RattachementModal'), {
    ssr: false,
})

const PrepareListItems = (listItems, merchListItems) => {
    let itemsToDisplay = [];
    if (!merchListItems || (merchListItems.length === 0 || merchListItems.items.length === 0)) {
        return listItems;
    }
    for (let i = 1; i <= listItems.length; i++) {
        let item = null;
        let index = merchListItems.positions.indexOf(i);
        if (index !== -1 && merchListItems.items[index] && merchListItems.items.length > 0) {
            item = merchListItems.items[index];
            item['type'] = 'merchAction';
            itemsToDisplay.push(item);
        }
        if (listItems[i - 1]) {
            item = listItems[i - 1];
            item['type'] = 'product';
            itemsToDisplay.push(item);
        }
    }
    return itemsToDisplay;
}
const getDiscountAti = (privateDiscount, originalPrice, price) => {
    if (privateDiscount && originalPrice) {
        return '"' + ((originalPrice - privateDiscount).toFixed(2)) + '"';
    } else if (originalPrice) {
        return '"' + ((originalPrice - price).toFixed(2)) + '"';
    }
    return null;
}
const prepareBreadcrumbId = (infoCategory) => {
    let breadcrumbId = '';
    if (infoCategory && infoCategory.parentsCategories) {
        infoCategory.parentsCategories.map((category) => {
            if (category.id) {
                breadcrumbId += category.id.substr(1) + '/'
            }

        });
        if (infoCategory.id) {
            breadcrumbId += infoCategory.id.substr(1);
        }
    }
    return (breadcrumbId);
}
const paginationNavigation = (totalPages, activePage) => {
    let links = [];

    if (totalPages > 3) {
        // this specifies the range of pages we want to show in the middle
        const min = Math.max(
            totalPages - activePage <= 3 ? totalPages - 4 : activePage - 2,
            2
        );
        const max = Math.min(
            activePage <= 4 ? 5 : activePage + 2,
            totalPages - 1
        );

        // we always show the first page
        links.push(1);

        // we're more than one space away from the beginning, so we need a separator
        if (min > 2) {
            links.push("...");
        }

        // generate the middle numbers
        for (let i = min; i < max + 1; ++i) {
            links.push(i);
        }

        // we're more than one space away from the end, so we need a separator
        if (max < totalPages - 1) {
            links.push("...");
        }

        // we always show the last page
        links.push(totalPages);
    } else {
        // we must special-case three or less, because the above logic won't work
        // generate the middle numbers
        for (let i = 1; i <= totalPages; ++i) {
            links.push(i);
        }
    }
    return links
}
const checkAdSenseContentHtml = (setAdsenseContentHtml) => {
    let ads = document.querySelector('.dp__products__promoAddSenseBanners .adsbygoogle');
    const sponsoredDivItems = document.querySelectorAll('.vzbl-d');
    if (ads && ads.getAttribute('data-ad-status') === 'unfilled') {
        setAdsenseContentHtml(false)
    } else {
        // cas de test en local et preprod
        setAdsenseContentHtml(true)
    }
    if (sponsoredDivItems) {
        if (ads && ads.getAttribute('data-ad-status') === 'unfilled') {
            sponsoredDivItems.forEach(function (sponsoredDivItems) {
                sponsoredDivItems.classList.add('full');
            });
        } else {
            sponsoredDivItems.forEach(function (sponsoredDivItems) {
                sponsoredDivItems.classList.remove('full');
            });
        }
    }
}
const renderPlaceHolderForPagination = (apiStatusPending, listType, isAutoPromoBanners, itemCount) => {
    let placeHolderArray = [...Array(listType === 'list' ? 6 : 16).keys()]
    return placeHolderArray.map(() => {
        itemCount++;
        return (
            <>
                <Placeholder apiStatusPending={apiStatusPending} listType={listType}
                             isAutoPromoBanners={listType === 'grid' ? '' : isAutoPromoBanners}/>
                {((listType === 'grid') && (itemCount !== undefined) && ((itemCount + 1) % 4 === 0)) &&
                    <div className="separator"/>
                }
            </>
        )
    })
}
const List = ({
                  listType,
                  productsListData,
                  productsAvailabilityData,
                  filters,
                  getProducts,
                  availabilityDisplayMode,
                  apiStatusPending,
                  adsenseStatus,
                  currentFiltersValue,
                  keyWords,
                  showPreviousPage,
                  previousPager,
                  isPaginationLoading,
                  isSeeMoreLoader,
                  category,
                  isSearch,
                  htOptin
              }) => {
    const {listItems, itemsCount, pager, merchListItems, metaInfos, adaptiveLoadingResources} = productsListData;
    let listItemsToDisplay = PrepareListItems(listItems.values, merchListItems);
    const shop = useSelector(state => state.header.shop?.shopInfos)
    const [links, setLinks] = useState([]);
    const [lastProductListItemsLength, setLastProductListItemsLength] = useState(0);
    const [adsenseContentHtml, setAdsenseContentHtml] = useState(true);
    const productListParams = useMemo(() => {
        return {
            currentSort: productsListData?.currentSort,
            categoryId: category?.id,
            currentFiltersValue: currentFiltersValue,
            pageIndex: productsListData?.pager ? productsListData.pager.currentPageIndex + 1 : null,
            pager: pager,
            availabilityFiltersCodes: Utils.prepareAllShopsProductAvailabilityFilterValue(filters),
            keyWords: keyWords
        };
    }, [productsListData, currentFiltersValue, keyWords]);
    let autoPromoBannersHtmlContent = Utils.getMetaInfosValueByCode('autoPromoBannersHtmlContent', productsListData?.metaInfos)
    let isAutoPromoBanners = autoPromoBannersHtmlContent || (adsenseStatus && adsenseContentHtml) ? '' : 'full'
    let index = 0;
    useEffect(() => {
        checkAdSenseContentHtml(setAdsenseContentHtml)
        setLinks(paginationNavigation(pager.pageCount, pager.currentPageIndex + 1))
        setLastProductListItemsLength(listItems.length > pager.currentPageIndex * pager.pageSize ? listItems.length - (pager.currentPageIndex * pager.pageSize) : listItems.length)
    }, [pager])
    useEffect(() => {
        const observerOptions = {
            childList: true,
            subtree: true,
            attributes:true
        };
        const observeAdElement = () => {
            const adElements = document.getElementsByClassName('adsbygoogle');
            if (adElements.length > 0) {
                const adElement = adElements[0];
                const observer = new MutationObserver(() => {
                    checkAdSenseContentHtml(setAdsenseContentHtml)
                });
                observer.observe(adElement, observerOptions);
            }
        };
        observeAdElement();
        const bodyObserver = new MutationObserver(observeAdElement);
        bodyObserver.observe(document.body, observerOptions);
    }, []);
    let indexProduct = -1;
    return (
        <div className="dp__content">
            <p className="dp__content__numberProducts"><strong>{itemsCount} {itemsCount > 1 ? 'produits' : 'produit'}</strong></p>
            {isSearch ||
                <div className="target2sell" id='PPNA1QL127P68J-1405-135'/>
            }
            {showPreviousPage && previousPager.currentPageIndex - 1 >= 0 &&
                <SeePaginatorButton className={'dp__content-previous'} title={'Voir les produits précédents'}
                                    label={'Voir les produits précédents'} context={'seePrevious'} previousPager={previousPager}
                                    seeProducts={getProducts}/>}
            <div className={`dp__products ${listType}`}>
                {(listType === 'list' && autoPromoBannersHtmlContent) &&
                    <AutoPromoAddSenseBanners autoPromoBannersHtmlContent={autoPromoBannersHtmlContent}/>}
                {isPaginationLoading && !isSeeMoreLoader && renderPlaceHolderForPagination(apiStatusPending, listType, isAutoPromoBanners, indexProduct)}
                {listItemsToDisplay.map((listItemToDisplay, key) => {
                        indexProduct++
                        return (
                            <>
                                {listItemToDisplay.type === "merchAction" ?
                                    <ProductCellBanner
                                        listType={listType}
                                        isPaginationLoading={isPaginationLoading}
                                        isAutoPromoBanners={isAutoPromoBanners}
                                        listItemToDisplay={listItemToDisplay}
                                        apiStatusPending={apiStatusPending}
                                    /> :
                                    <ProductCell
                                        apiStatusPending={apiStatusPending}
                                        isAutoPromoBanners={isAutoPromoBanners}
                                        isPaginationLoading={isPaginationLoading}
                                        productPosition={index++}
                                        productIndex={key}
                                        listType={listType}
                                        ean={listItemToDisplay[19]}
                                        flyerId={listItemToDisplay[33]}
                                        rangeLabel={listItemToDisplay[23]}
                                        isPei={listItemToDisplay[3] !== null}
                                        breadcrumbId={prepareBreadcrumbId(category)}
                                        getDiscountAti={getDiscountAti}
                                        unitPriceWithoutTax={listItemToDisplay[25]}
                                        id={listItemToDisplay[6]}
                                        images={listItemToDisplay[18]}
                                        commercialSticker={listItemToDisplay[3]}
                                        brand={listItemToDisplay[9]}
                                        shortTitle={listItemToDisplay[15]}
                                        title={listItemToDisplay[5]}
                                        productsAvailabilityData={productsAvailabilityData}
                                        availabilityDisplayMode={availabilityDisplayMode}
                                        availabilityShopIdListFilter={'AvailabilityShopIdList'}
                                        availabilityDataByShops={listItemToDisplay[34]}
                                        productSheetUrl={Utils.getMetaInfosValueByCode("productSheetUrl", listItemToDisplay[12])}
                                        price={listItemToDisplay[7]}
                                        priceWithoutTax={listItemToDisplay[25]}
                                        originalPrice={listItemToDisplay[1]}
                                        originalPriceWithoutTax={listItemToDisplay[35]}
                                        discount={listItemToDisplay[10]}
                                        productNote={listItemToDisplay[20]}
                                        reviewRate={listItemToDisplay[2]}
                                        featuresGroups={Utils.getGroupeFeatures("LesPlus", listItemToDisplay[21])}
                                        soldBy={listItemToDisplay[4]}
                                        offersNumber={listItemToDisplay[26]}
                                        offersState={listItemToDisplay[28]}
                                        cheapestOfferPrice={listItemToDisplay[27]}
                                        cheapestOfferPriceWithoutTax={listItemToDisplay[37]}
                                        filters={filters}
                                        privateSalePrice={listItemToDisplay[8]}
                                        privateSalePriceWithoutTax={listItemToDisplay[36]}
                                        privateDiscount={listItemToDisplay[11]}
                                        commercialOperations={listItemToDisplay[17]}
                                        metaData={listItemToDisplay[12]}
                                        cheapestIsBestOffer={listItemToDisplay[29]}
                                        bestOfferSellerName={listItemToDisplay[32]}
                                        maxDisplayedPicto={Utils.getMetaInfosValueByCode("desktopMaxDisplayedStickersProductList", metaInfos)}
                                        htOptin={htOptin}
                                    />
                                }
                                {((listType === 'grid') && (indexProduct !== undefined) && ((indexProduct + 1) % 4 === 0)) &&
                                    <div className="separator"/>
                                }
                            </>)
                    }
                )}
                {isPaginationLoading && isSeeMoreLoader && renderPlaceHolderForPagination(apiStatusPending, listType, isAutoPromoBanners, indexProduct)}
            </div>
            <DynamicComponentPaginator
                listItemsCount={pager.currentPageIndex === 0 ? listItems.values.length : (pager.currentPageIndex + 1 === pager.pageCount ) ? (pager.currentPageIndex * pager.pageSize) + lastProductListItemsLength : (pager.pageSize * (pager.currentPageIndex + 1))}
                                       pager={pager}
                                       links={links}
                                       context={'seeMore'}
                                       productItemCount={itemsCount ? itemsCount : 0}
                                       activePage={pager.currentPageIndex + 1}
                                       seeProducts={getProducts} isSearch={!!isSearch} />

            {adsenseStatus &&
                <div align="center">
                    <AdsenseBloc
                        style={{
                            "display": 'inline-block',
                            "width": '728px',
                            "height": '90px',
                            "marginBottom": '18px',
                        }}
                        resources={adaptiveLoadingResources}
                        dataAdClient="ca-pub-5844672657887373" dataAdSlot="5925553845"/></div>}
            {!shop && <RattachementModalWithNoSSR productListParams={productListParams}/>}
        </div>
    );
};

export default List;
